export const removeBlankSpaces = (text) => typeof text === "string" ? text.replace(/\s/g, '') : '';

export const computSimpleHashFromData = (data) => JSON.stringify(data);

export const removeAccentsAndLowercase = (text) => 
    typeof text === "string" 
        ? text.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase() 
        : '';